// extracted by mini-css-extract-plugin
export default {"modalWindow":"transition_modalWindow__+BmLp"};